export type ReportDTO = {
  id: string;
  reportId?: number;
  universityName: string;
  city: string;
  bin: string;
  uploadedDate: number[];
  firstUploadedDate?: number[];
  period: PeriodDTO;
  status?: ReportStatus | null;
  isIntegrationCreated: boolean;
  isCorrection?: boolean;
  paidProcessingError?: string;
  paidProcessingErrorDate?: number[] | string;
  numberOfStudents: number;
  comment: string;
  cmsInfo: string;
  hasFundingId4?: boolean;
  hasFunding204?: boolean;
  universityId?: number;
  managerName?: string;
};

/** Строка вкладки дашборда «По вузам» (GET /reports/university-statuses). */
export type ReportUniversityStatusDTO = {
  universityName: string;
  status?: ReportStatus | null;
  numberOfStudents?: number | null;
  hasFundingId4?: boolean;
};

export type ReportStateDTO = {
  id: string;
  status: ReportState;
  debugs: ReportDebug[];
  errorMessage?: string;
};

export type ReportDebug = {
  iin: string;
  firstName: string;
  lastName: string;
  middleName: string;
  universityName: string;
};

export enum ReportState {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
}

export type UniversityDTO = {
  id: string;
  universityId: number;
  nameRu: string;
  nameKz: string;
  nameEn: string;
  bin: string;
  shortNameRu: string;
  ownershipType: number;
};

export type UniversityInfo = {
  universityName: string;
  code: number;
  ecoCode: string;
  managerName?: string;
  reports: ReportDTO[];
};
export type UniversityResponsibleDTO = {
  id: string;
  universityId: string;
  universityName: string;
  userId: string;
  userFullName: string;
  shortNameRu: string; // city from university
  bin: string;
  universityResponsible: any;
};
export type StudentDTO = {
  id: string;
  studentId: number;
  citizenshipId: number;
  iin: string;
  iinValidation?: string;
  iinError?: string;
  firstName: string;
  lastName: string;
  patronymic: string;
  degreeId: number;
  course: number;
  isGraduationCourse: boolean;
  admissionYear: number;
  gop: string;
  fundingId: number;
  paymentFormId: number;
  additionalStatusId: number;
  commentOvpo: string;
  isDeducted: boolean;
  isSightInvalid: boolean;
  sightInvalidBegin: string;
  sightInvalidEnd: string;
  isHearingInvalid: boolean;
  hearingInvalidBegin: string;
  hearingInvalidEnd: string;
  isOrphan: boolean;
  isStateProvisionOrphan: boolean;
  commentFc: string;
  enrollOrderDate: string;
  enrollOrderNumber: string;
  enrollOrderMoveDate: string;
  deductOrderDate: string;
  deductOrderNumber: string;
  deductOrderMoveDate: string;
  deductOrderTransferDate: string;
  deductOrderTransferNumber: string;
  deductOrderTransferMoveDate: string;
  deductOrderTransferUniversityDomestic: string;
  deductOrderTransferUniversityForeign: string;
  academicLeaveOrderDate: string;
  academicLeaveOrderNumber: string;
  academicLeaveOrderMoveDate: string;
  academicLeaveOrderStartDate: string;
  academicLeaveOrderFinishDate: string;
  academicLeaveOrderReason: number;
  academicLeaveOrderSickLeaveStartDate: string;
  academicLeaveOrderSickLeaveFinishDate: string;
  orderChangeGopDate: string;
  orderChangeGopNumber: string;
  orderChangeGopMoveDate: string;
  orderChangeGopOldGop: string;
  orderChangePaymentFormGrantDate: string;
  orderChangePaymentFormGrantNumber: string;
  orderChangePaymentFormGrantMoveDate: string;
  orderAcademicMobilityDate: string;
  orderAcademicMobilityNumber: string;
  orderAcademicMobilityMoveDate: string;
  orderAcademicMobilityUniversityDomestic: string;
  orderAcademicMobilityUniversityForeign: string;
  orderAcademicMobilityStartDate: string;
  orderAcademicMobilityFinishDate: string;
  orderDoubleEducationDate: string;
  orderDoubleEducationNumber: string;
  orderDoubleEducationMoveDate: string;
  orderDoubleEducationUniversityDomestic: string;
  orderDoubleEducationUniversityForeign: string;
  orderDoubleEducationStartDate: string;
  orderDoubleEducationFinishDate: string;
  enrollOrderFoundDate: string;
  enrollOrderFoundNumber: string;
  enrollOrderFoundMoveDate: string;
  deductOrderFoundDate: string;
  deductOrderFoundNumber: string;
  deductOrderFoundMoveDate: string;
  quotaId: number;
  environmentalFactorId: number;
  universityId: number;
  universityName: string;
  reportId: number;
  year: number;
  periodId: number;
  reportStatusId: number;
  iik: string;
  bik: string;
  hasBranchEf: boolean;
  environmentalFactor: number;
  orderScholarshipDate: string;
  orderScholarshipNumber: string;
  scholarshipPeriodStart: string;
  scholarshipPeriodEnd: string;
  scholarshipType: string;
  orderScholarshipFoundDate: string;
  orderScholarshipFoundNumber: string;
  listenerScholarshipPeriodStart: string;
  listenerScholarshipPeriodEnd: string;
  listenerScholarshipType: string;
  remarks: Remark[];
  scholarship: number;
  category: string;
  performance: string;
  speciality: string;
  formula: string;
  certificates: Certificate[];
  reasonRefund: string;
  status: RefundStatus;
  statusMessage: string;
  debtScholarship: number;
  paidScholarship: number;
  wasInAcademicMobility: boolean;
  debtPaid: boolean;
  fieldDifferences: Difference[];
  /** NEW, CHANGED, UNCHANGED, REMOVED — сравнение с прошлой версией отчёта */
  versionChange?: string;
  versionDiff?: Difference[];
  isNew: boolean;
  isDeleted: boolean;
  isUpdated: boolean;
  is118Mark: boolean;
};
export type StudentScholarshipDTO = {
  id: string;
  studentId: number;
  iin: string;
  iinValidation?: string;
  iinError?: string;
  firstName: string;
  lastName: string;
  patronymic: string;
  referenceNumber: string;

  universityId: number;
  universityName: string;
  report: string;
  reportId: number;
  year: number;
  periodId: number;
  periodDate: string;
  formula: string;
  scholarship: string;
  scholarshipVal: number;
  reportDate: string;
  startDate: string;
  endDate: string;
};

export type Difference = {
  fieldName: string;
  oldValue: object;
  newValue: object;
};

export type ScholarshipRecalculationChange = {
  id: string;
  lastName?: string;
  firstName?: string;
  patronymic?: string;
  iin?: string;
  iinValidation?: string;
  iinError?: string;
  gop?: string;
  fundingId?: number;
  oldScholarship?: number | string | null;
  newScholarship?: number | string | null;
  oldFormula?: string | null;
  newFormula?: string | null;
  errorMessage?: string | null;
};

export type ScholarshipRecalculationResult = {
  totalCount: number;
  changedCount: number;
  unchangedCount: number;
  skippedCount: number;
  errorCount: number;
  changes: ScholarshipRecalculationChange[];
  errors: ScholarshipRecalculationChange[];
};

export type StudentSearchDTO = {
  iin?: string;
  firstName?: string;
  lastName?: string;
  gop?: string;
  fundingId?: number;
  degreeId?: number;
  universityId?: number;
  year?: number;
  periodIds?: number[];
  filters?: StudentFilter[];
  paymentStatus?: string;
  statusMessage?: string;
  statusMessageBlank?: boolean;
  remarkId?: string;
  /** Сравнение с прошлой версией отчёта: check, fixed, notfixed, nonote, new, removed, same, reqfixed, reqsame */
  versionChange?: string;
};

export type ReportSummaryStatus = {
  status?: string;
  count: number;
  scholarship: number;
};

export type ReportSummary = {
  total: number;
  totalScholarship: number;
  added: number;
  updated: number;
  deleted: number;
  withRemark: number;
  zeroScholarship: number;
  statuses: ReportSummaryStatus[];
  remarks: { remarkId: string; count: number }[];
  versionCounts?: Record<string, number>;
  version?: {
    number: number;
    currentDate?: string | number[];
    previousDate?: string | number[];
    compared: boolean;
  };
};

export type StudentPaymentDTO = {
  id: string;
  reportId?: number;
  year?: number;
  periodId?: number;
  universityId?: number;
  universityName?: string;
  gop?: string;
  fundingId?: number;
  scholarship?: number;
  status?: string;
  deleted?: boolean;
};

export type StudentGroupDTO = {
  id: string;
  iin?: string;
  lastName?: string;
  firstName?: string;
  patronymic?: string;
  payments?: StudentPaymentDTO[];
};

export type PaymentStatusFilter = {
  status?: string;
  statusMessage?: string;
  count: number;
};
export type StudentScholarshipSearchDTO = {
  iins?: string;
  startDate?: string;
  endDate?: string;
};

export type UniversityResponsibleSearchDTO = {
  universityId?: string;
  universityName?: string;
  userId?: string;
  city?: string;
  bin?: string;
};
export type StudentFilter = {
  name: string;
  value: string;
  color?: string;
};

export type ReportSearchDTO = {
  name?: string;
  period?: PeriodDTO;
  status?: ReportStatus;
  ministry?: "MNVO" | "MZ" | "BOTH";
  reportId?: number;
};

export type Page<T> = {
  totalPages: number;
  totalElements: number;
  size: number;
  content: T[];
  number: number;
  sort: SortDTO;
  first: boolean;
  last: boolean;
  numberOfElements: number;
  pageable: PageableDTO;
  empty: boolean;
  scholarshipSum?: number;
};

export type SortDTO = { sorted: boolean; unsorted: boolean; empty: boolean };

export type PageableDTO = {
  offset?: number;
  sort?: SortDTO;
  pageNumber: number;
  pageSize: number;
  unpaged?: boolean;
  paged?: boolean;
};

export enum RefundStatus {
  REFUND = "REFUND",
  MT102_INCLUDED = "MT102_INCLUDED",
  MT102_NOT_INCLUDED = "MT102_NOT_INCLUDED",
  SYSTEM_REFUND = "SYSTEM_REFUND",
  PAID = "PAID",
  SCHOLARSHIP_CALCULATED = "SCHOLARSHIP_CALCULATED",
}

export type RefundIinAmount = {
  iin: string;
  pdfAmount?: number;
  scholarship?: number;
};

export type RefundPdfPreview = {
  iins: string[];
  missingIins: string[];
  pdfSum?: number;
  reportSum?: number;
  amounts?: RefundIinAmount[];
};

export const REFUND_MESSAGE_PRESETS = [
  "неверные реквизиты получателя",
  "Счет имеет блокировки",
];

export type PeriodDTO = {
  period?: string;
  monthValue?: string;
  day?: number;
  displayValue?: string;
  year?: number;
};

export type Order = {
  id: string;
  type: OrderType;
  category: CategoryType;
  typeValue: string;
  categoryValue: string;
};

export type ReportSignDTO = {
  id: string;
  hash: string;
  xml: string;
};

export enum CategoryType {
  TRANSFER_TO_ANOTHER_UNIVERSITY = "TRANSFER_TO_ANOTHER_UNIVERSITY",
  FROM_ONE_EDUCATIONAL_GROUP_TO_ANOTHER = "FROM_ONE_EDUCATIONAL_GROUP_TO_ANOTHER",
  CONSCRIPTION = "CONSCRIPTION",
  HEALTH = "HEALTH",
  AT_BIRTH_OR_ADOPTION_OF_A_CHILD = "AT_BIRTH_OR_ADOPTION_OF_A_CHILD",
  CANCELLATION_OF_A_GRANT = "CANCELLATION_OF_A_GRANT",
  TRANSFER_TO_GRANT = "TRANSFER_TO_GRANT ",
}

export enum OrderType {
  ORDER_OF_ADMISSION = "ORDER_OF_ADMISSION",
  EXPULSION_ORDER = "EXPULSION_ORDER",
  TRANSFER_ORDER = "TRANSFER_ORDER",
  ACADEMIC_LEAVE_ORDER = "ACADEMIC_LEAVE_ORDER",
  RECOVERY_ORDER = "RECOVERY_ORDER",
  ORDER_TO_CHANGE_FORM_OF_PAYMENT = "ORDER_TO_CHANGE_FORM_OF_PAYMENT",
  ORDER_TO_TRANSFER_FROM_COURSE_TO_COURSE = "ORDER_TO_TRANSFER_FROM_COURSE_TO_COURSE",
  ACADEMIC_MOBILITY_LEAVE_ORDER = "ACADEMIC_MOBILITY_LEAVE_ORDER",
  ACADEMIC_MOBILITY_RETURN_ORDER = "ACADEMIC_MOBILITY_RETURN_ORDER",
  DOUBLE_DEGREE_EDUCATION_STUDY_ORDER = "DOUBLE_DEGREE_EDUCATION_STUDY_ORDER",
  DOUBLE_DEGREE_EDUCATION_STUDY_FINISH_ORDER = "DOUBLE_DEGREE_EDUCATION_STUDY_FINISH_ORDER",
  PREPARATORY_DEPARTMENT_ORDER_OF_ADMISSION = "PREPARATORY_DEPARTMENT_ORDER_OF_ADMISSION",
  PREPARATORY_DEPARTMENT_EXPULSION_ORDER = "PREPARATORY_DEPARTMENT_EXPULSION_ORDER ",
}

export type Certificate = {
  certificateFileId: string;
  studentId: number;
  documentType: CertificateType;
  filename: string;
};

export enum CertificateType {
  INVALID_VISUALLY = "INVALID_VISUALLY",
  INVALID_HEARING = "INVALID_HEARING",
  ORPHAN = "ORPHAN",
  ORPHAN_FULL_PROVISION = "ORPHAN_FULL_PROVISION",
  PREGNANCY_CHILDBIRTH = "PREGNANCY_CHILDBIRTH",
  TUBERCULOSIS = "TUBERCULOSIS",
  OTHER_MED_CONDITIONS = "OTHER_MED_CONDITIONS",
  FOR_HEALTH = "FOR_HEALTH",
  BIRTH_CHILD = "BIRTH_CHILD",
}

export type SupportingDocument = {
  id: string;
  code: CertificateType;
  value: string;
};

export type AcademicLeaveReason = {
  id: string;
  reasonId: number;
  valueRu: string;
};

export type Remark = {
  remarkId: string;
  remarkName: string;
  comment: string;
  /** Замечание поставил расчётник, а не автоматический расчёт */
  manual?: boolean;
};

export type RemarkType = {
  id: string;
  type: string;
  value: string;
};

export type MT102CreateDTO = {
  number: string;
  date: Date;
  serviceNumber: string;
  serviceDate: Date;
  comment?: string;
  useOldBank?: boolean;
};

export enum ReportStatus {
  LOADED = "LOADED",
  PENDING = "PENDING",
  FOR_REVISION = "FOR_REVISION",
  ACCEPTED = "ACCEPTED",
  SCHOLARSHIP_CALCULATION = "SCHOLARSHIP_CALCULATION",
  APPROVED_BY_UNIVERSITY = "APPROVED_BY_UNIVERSITY",
  MT102 = "MT102",
  MT102_CREATED = "MT102_CREATED",
  PAID_IN_PART = "PAID_IN_PART",
  PAID = "PAID",
  ERROR = "ERROR",
}

export const ReportStatusLabels: Record<ReportStatus, string> = {
  [ReportStatus.ACCEPTED]: "Принят",
  [ReportStatus.LOADED]: "Загружен",
  [ReportStatus.FOR_REVISION]: "На доработку",
  [ReportStatus.MT102]: "МТ102",
  [ReportStatus.MT102_CREATED]: "МТ102 загружен",
  [ReportStatus.PAID]: "Выплачен",
  [ReportStatus.PAID_IN_PART]: "Выплачен частично",
  [ReportStatus.PENDING]: "На рассмотрении",
  [ReportStatus.SCHOLARSHIP_CALCULATION]: "Рассчит стип",
  [ReportStatus.APPROVED_BY_UNIVERSITY]: "Расчет готов",
  [ReportStatus.ERROR]: "Ошибка",
};

export const RECALCULATABLE_REPORT_STATUSES: ReportStatus[] = [
  ReportStatus.LOADED,
  ReportStatus.PENDING,
  ReportStatus.FOR_REVISION,
  ReportStatus.ACCEPTED,
  ReportStatus.SCHOLARSHIP_CALCULATION,
];

export const REPORT_PROCESSING_LABEL = "Обрабатывается";
export const REPORT_UPLOAD_FAILED_LABEL = "Ошибка загрузки";

export function getReportStatusLabel(
  status?: ReportStatus | null
): string {
  if (!status) {
    return REPORT_PROCESSING_LABEL;
  }
  return ReportStatusLabels[status] ?? status;
}

export enum ReportType {
  AdditionalСonsolidatedReport = "AdditionalСonsolidatedReport",
  AdditionalСonsolidatedReportFull = "AdditionalСonsolidatedReportFull",
  Mark118AdditionalСonsolidatedReport = "Mark118AdditionalСonsolidatedReport",
  ScholarshipCalculationReport = "ScholarshipCalculationReport",
}

export enum ExportType {
  CSV = "CSV",
  ZIP = "ZIP",
  XLSX = "XLSX",
}

export type ReportStudentDTO = {
  id: string;
  fullname: string;
  idNumber: string;
  category: string;
  level: string;
  specialty: string;
  socialStatus: string;
  performance: string;
  scholarship: number;
  formula: string;
};

export type AdjustmentDTO = {
  operation?: AdjustmentOperationType;
  value?: number;
  comment?: string;
};

export enum AdjustmentOperationType {
  ADD = "ADD",
  SUBTRACT = "SUBTRACT",
}

export type ReportBankData = {
  bankName: string;
  studentsCount: number;
  totalScholarship: number;
  mark118StudentsCount: number;
  mark118TotalScholarship: number;
  mark324StudentsCount: number;
  mark324TotalScholarship: number;
};

export type ExcludedPaymentStudent = {
  iin: string;
  lastName: string;
  firstName: string;
  patronymic: string;
  iik: string;
  bik: string;
  problem: string;
  scholarship: number;
};

export type ReportPaymentList = {
  banks: ReportBankData[];
  excludedRows?: ReportBankData[];
  excluded?: ExcludedPaymentStudent[];
  skipped?: { reason: string; count: number; scholarship: number }[];
  refundOnly?: boolean;
};

export type FormulaDTO = {
  fullFormula: string;
  formula: string;
  values: any;
  sum: number;
};

export type OvpoData = {
  fileName: string;
  status: OvpoStatus;
  errorMessage: string;
}

export enum OvpoStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS"
}
